import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-document-limit-exceeded-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './document-limit-exceeded-dialog.component.html',
  styleUrls: ['./document-limit-exceeded-dialog.component.scss']
})
export class DocumentLimitExceededDialogComponent {
  private readonly _router = inject(Router);
  
  constructor(
    public dialogRef: MatDialogRef<DocumentLimitExceededDialogComponent>
  ) {}

  goToSubscription(): void {
    this.dialogRef.close();
    this._router.navigate(['/konto/subskrypcje']);
  }

  close(): void {
    this.dialogRef.close();
  }
}
